/* Registers — register switcher, named-view segments and the table, in the shell's language
 * (13-15). The register switcher is the app bar's pill idiom (lavender = the current one,
 * purple-dark ink); the named views are a quieter segmented control on a white rail, with the
 * chosen view in sage, so the two levels never read as the same control. */

/* The page-head lede (mock .pagehead p). */
.intro {
  margin: 8px 0 28px;
  max-width: 66ch;
  font-size: 15px;
  color: var(--gray);
}

/* ── Register switcher (primary tabs; mock .surfaces) ── */
.registerTabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--line);
}

.registerTab {
  padding: 7px 15px;
  background: none;
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  color: var(--gray);
  transition: background-color 0.2s, color 0.2s;
}

.registerTab:hover {
  background-color: var(--lavender-light);
  color: var(--purple-dark);
}

.registerTab:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}

.registerTabActive,
.registerTabActive:hover {
  background-color: var(--lavender);
  color: var(--purple-dark);
}

/* ── Named-view segments (secondary; a segmented rail) ── */
.viewSegments {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 20px;
  padding: 3px;
  border: 1px solid var(--sage-dark);
  border-radius: 20px;
  background-color: var(--white);
}

.viewSegment {
  padding: 5px 13px;
  background: none;
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  font: inherit;
  font-size: 12.8px;
  font-weight: 600;
  color: var(--gray);
  transition: background-color 0.2s, color 0.2s;
}

.viewSegment:hover {
  background-color: var(--sage-light);
  color: var(--charcoal);
}

.viewSegment:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}

.viewSegmentActive,
.viewSegmentActive:hover {
  background-color: var(--sage);
  color: var(--charcoal);
}

/* ── Risk "By rating" grouped list ── */
.ratingGroups {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.ratingGroup {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* A rating group's heading: the mock's serif section heading (.rail h3), not a capital label. */
.ratingHeading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-family: var(--serif);
  font-weight: 500;
  font-size: 20px;
  line-height: 1.2;
  color: var(--charcoal);
}

.ratingDot {
  width: 10px;
  height: 10px;
  border-radius: var(--radius-full);
  background-color: var(--gray-light);
  flex-shrink: 0;
}

.dot-extreme,
.dot-high {
  background-color: var(--red);
}

.dot-medium {
  background-color: var(--amber);
}

.dot-low {
  background-color: var(--green);
}

.dot-unrated {
  background-color: var(--gray-light);
}
